module.exports = __webpack_public_path__ + "img/policies-main.3c72e90d.png";